<div class="address-label">
  <div *ngIf="safe(label?.fullName)" class="label-fullname">{{ safe(label?.fullName) }}</div>
  <div *ngIf="safe(label?.companyName)" class="label-company">{{ safe(label?.companyName) }}</div>
  <div *ngIf="safe(label?.addressLine1)" class="label-addr1">{{ safe(label?.addressLine1) }}</div>
  <div *ngIf="safe(label?.addressLine2)" class="label-addr2">{{ safe(label?.addressLine2) }}</div>
  <div *ngIf="cityStateZip" class="label-city-state-zip">{{ cityStateZip }}</div>
  <div *ngIf="safe(label?.country)" class="label-country">{{ safe(label?.country) }}</div>
  <div *ngIf="safe(label?.phoneNumber)" class="label-phone">{{ safe(label?.phoneNumber) }}</div>
  <div *ngIf="idDisplay" class="label-id">{{ idDisplay }}</div>
</div>
